import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface MeData {
  user: {
    id: string;
    name: string;
    email: string | null;
    weeklyDigest: boolean;
    [key: string]: unknown;
  };
}

export function useEmailSettings() {
  const queryClient = useQueryClient();

  const meQuery = useQuery<MeData>({
    queryKey: ['me'],
    queryFn: async () => {
      const res = await api.get('/me');
      return res.data;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (data: { email?: string | null; weeklyDigest?: boolean }) => {
      const res = await api.patch('/me', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });

  return {
    email: meQuery.data?.user.email ?? null,
    weeklyDigest: meQuery.data?.user.weeklyDigest ?? false,
    isLoading: meQuery.isLoading,
    update: updateMutation.mutateAsync,
    isSaving: updateMutation.isPending,
  };
}
